/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createWorkPackagePriority } from '../fn/work-package-priorities/create-work-package-priority';
import { CreateWorkPackagePriority$Params } from '../fn/work-package-priorities/create-work-package-priority';
import { deleteWorkPackagePriority } from '../fn/work-package-priorities/delete-work-package-priority';
import { DeleteWorkPackagePriority$Params } from '../fn/work-package-priorities/delete-work-package-priority';
import { getWorkPackagePriority } from '../fn/work-package-priorities/get-work-package-priority';
import { GetWorkPackagePriority$Params } from '../fn/work-package-priorities/get-work-package-priority';
import { listWorkPackagePriorities } from '../fn/work-package-priorities/list-work-package-priorities';
import { ListWorkPackagePriorities$Params } from '../fn/work-package-priorities/list-work-package-priorities';
import { updateWorkPackagePriority } from '../fn/work-package-priorities/update-work-package-priority';
import { UpdateWorkPackagePriority$Params } from '../fn/work-package-priorities/update-work-package-priority';
import { WorkPackagePriorityDto } from '../models/work-package-priority-dto';
import { WorkPackagePriorityDtoPage } from '../models/work-package-priority-dto-page';

@Injectable({ providedIn: 'root' })
export class WorkPackagePrioritiesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listWorkPackagePriorities()` */
  static readonly ListWorkPackagePrioritiesPath = '/v0/workPackagePriorities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listWorkPackagePriorities()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackagePriorities$Response(params?: ListWorkPackagePriorities$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackagePriorityDtoPage>> {
    return listWorkPackagePriorities(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listWorkPackagePriorities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackagePriorities(params?: ListWorkPackagePriorities$Params, context?: HttpContext): Observable<WorkPackagePriorityDtoPage> {
    return this.listWorkPackagePriorities$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackagePriorityDtoPage>): WorkPackagePriorityDtoPage => r.body)
    );
  }

  /** Path part for operation `getWorkPackagePriority()` */
  static readonly GetWorkPackagePriorityPath = '/v0/workPackagePriorities/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkPackagePriority()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackagePriority$Response(params: GetWorkPackagePriority$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackagePriorityDto>> {
    return getWorkPackagePriority(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWorkPackagePriority$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackagePriority(params: GetWorkPackagePriority$Params, context?: HttpContext): Observable<WorkPackagePriorityDto> {
    return this.getWorkPackagePriority$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackagePriorityDto>): WorkPackagePriorityDto => r.body)
    );
  }

  /** Path part for operation `updateWorkPackagePriority()` */
  static readonly UpdateWorkPackagePriorityPath = '/v0/workPackagePriorities/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateWorkPackagePriority()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWorkPackagePriority$Response(params: UpdateWorkPackagePriority$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackagePriorityDto>> {
    return updateWorkPackagePriority(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateWorkPackagePriority$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWorkPackagePriority(params: UpdateWorkPackagePriority$Params, context?: HttpContext): Observable<WorkPackagePriorityDto> {
    return this.updateWorkPackagePriority$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackagePriorityDto>): WorkPackagePriorityDto => r.body)
    );
  }

  /** Path part for operation `createWorkPackagePriority()` */
  static readonly CreateWorkPackagePriorityPath = '/v0/workPackagePriorities/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWorkPackagePriority()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackagePriority$Response(params: CreateWorkPackagePriority$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackagePriorityDto>> {
    return createWorkPackagePriority(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createWorkPackagePriority$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackagePriority(params: CreateWorkPackagePriority$Params, context?: HttpContext): Observable<WorkPackagePriorityDto> {
    return this.createWorkPackagePriority$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackagePriorityDto>): WorkPackagePriorityDto => r.body)
    );
  }

  /** Path part for operation `deleteWorkPackagePriority()` */
  static readonly DeleteWorkPackagePriorityPath = '/v0/workPackagePriorities/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteWorkPackagePriority()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWorkPackagePriority$Response(params: DeleteWorkPackagePriority$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteWorkPackagePriority(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteWorkPackagePriority$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWorkPackagePriority(params: DeleteWorkPackagePriority$Params, context?: HttpContext): Observable<void> {
    return this.deleteWorkPackagePriority$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
